export const REGISTER_ARTIST = "REGISTER_ARTIST";
export const REGISTER_ARTIST_SUCCESSFUL = "REGISTER_ARTIST_SUCESSS";
export const REGISTER_ARTIST_FAILED = "REGISTER_ARTIST_FAILED";
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
//  SUBSCRIBE
export const USER_SUBSCRIBE = "user_subscribe";
export const USER_SUBSCRIBE_SUCCESSFUL = "user_subscribe_successfull";
export const USER_SUBSCRIBE_FAILED = "user_subscribe_failed";

//  New Letter

export const NEWSLETTER = "NEWSLETTER";
export const NEWSLETTER_FAILED = "NEWSLETTER_FAILED";
export const NEWSLETTER_SUCCESSFUL = "NEWSLETTER_SUCESSS";

// TOP ARTIST
export const GETTOP_ARTIST = "GETTOP_ARTIST";
export const GETMYTOP_ARTIST_SUCCESSFUL = "GETTOP_ARTIST_SUCESSS";
export const GETTOP_ARTIST_FAILED = "GETTOP_ARTIST_FAILED";
